import { useEffect } from "react";

/** Client-provided Elfsight embed (load script once per page). */
export const ELFSIGHT_PLATFORM_SCRIPT =
  "https://elfsightcdn.com/platform.js";

/** Elfsight Google Reviews | Untitled Google Reviews (client embed) */
export const ELFSIGHT_GOOGLE_REVIEWS_CLASS =
  "elfsight-app-948f765b-471e-4c38-a1e6-ae35e2718248";

/** Elfsight Reviews from Tripadvisor | Untitled Reviews from Tripadvisor 2 (client embed) */
export const ELFSIGHT_TRIPADVISOR_REVIEWS_CLASS =
  "elfsight-app-149c58b0-d915-4619-97d6-228063abee35";

let elfsightScriptRequested = false;

export function ensureElfsightPlatformScript() {
  if (elfsightScriptRequested || typeof document === "undefined") {
    return;
  }

  const existing = document.querySelector(
    `script[src="${ELFSIGHT_PLATFORM_SCRIPT}"]`,
  );
  if (existing) {
    elfsightScriptRequested = true;
    return;
  }

  elfsightScriptRequested = true;
  const script = document.createElement("script");
  script.src = ELFSIGHT_PLATFORM_SCRIPT;
  script.async = true;
  document.body.appendChild(script);
}

function ElfsightReviewsEmbed({ title, widgetClassName }) {
  useEffect(() => {
    ensureElfsightPlatformScript();
  }, []);

  return (
    <div className="ib-tm-elfsight-wrap">
      {title ? <h3 className="ib-tm-elfsight-title">{title}</h3> : null}
      <div className={widgetClassName} data-elfsight-app-lazy />
    </div>
  );
}

/** Client Google embed: platform.js + elfsight-app-948f765b… */
export function ElfsightGoogleReviews({ title = "Google Reviews" }) {
  return (
    <ElfsightReviewsEmbed
      title={title}
      widgetClassName={ELFSIGHT_GOOGLE_REVIEWS_CLASS}
    />
  );
}

/** Client Tripadvisor embed: platform.js + elfsight-app-149c58b0… */
export function ElfsightTripadvisorReviews({ title = "Tripadvisor Reviews" }) {
  return (
    <ElfsightReviewsEmbed
      title={title}
      widgetClassName={ELFSIGHT_TRIPADVISOR_REVIEWS_CLASS}
    />
  );
}
